import InputFactory from "../InputFactory";

function ClientFilter({ progress, ...props }) {
  return (
    <div className="d-inline-flex align-items-center gap-2 bg-white border border-primary rounded-3 px-3 py-2 shadow-sm">
      {/* Icon Badge */}
      <div
        className="d-flex align-items-center justify-content-center bg-primary rounded-2 flex-shrink-0"
        style={{ width: "32px", height: "32px" }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="12" cy="7" r="4" stroke="white" strokeWidth="2" />
        </svg>
      </div>

      {/* Divider */}
      <div className="vr opacity-25" />

      {/* Label + Input or Loader */}
      <div className="d-flex flex-column">
        <span
          className="text-uppercase text-primary fw-bold"
          style={{ fontSize: "10px", letterSpacing: "0.08em" }}
        >
          Client
        </span>

        {progress ? (
          <div className="d-flex align-items-center gap-2 py-1">
            <div
              className="spinner-border spinner-border-sm text-primary"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <span className="text-muted" style={{ fontSize: "12px" }}>
              Fetching client...
            </span>
          </div>
        ) : (
          <InputFactory {...props} />
        )}
      </div>
    </div>
  );
}

export default ClientFilter;
